import React, { Fragment, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import { isValueEntered } from 'services/Validation';
import {
    showPortfolioLoader,
    onSavePortfolio,
    onPortfolioClose,
} from 'actions/portfolio';
import { inputFields, displayedImage, showErrors, modalHeader, initProps } from '../common';

const PortfolioAdd = () => {
    const dispatch = useDispatch();
    const addPortfolioState = useSelector(state => state.portfolios.addPortfolioState);
    const [selectedPortfolio, setSelectedPortfolio] = useState(initProps);
    const [formErrors, setFormErrors] = useState({ name: '' });
    const [formValid, setFormValid] = useState(false);

    useEffect(() => {
        setSelectedPortfolio(initProps());
    }, []);

    // using selectedFeature makes it behave like componentDidUpdate - effect takes place when selectedFeature changes
    useEffect(() => {
        setFormValid(false);
        validateForm();
    }, [selectedPortfolio]);

    const handleUserInput = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        updateSelectedPortfolioField(name, value);
        validateField(name, value);
    };

    const updateSelectedPortfolioField = (fieldName, value) => {
        const newPortfolio = { ...selectedPortfolio };
        newPortfolio[fieldName] = value;
        setSelectedPortfolio(newPortfolio);
    };

    const validateField = (fieldName, value) => {
        const valueEntered = isValueEntered(value);
        formErrors[fieldName] = valueEntered ? '' : ' is invalid';
        setFormErrors(formErrors);
        validateForm();
    };

    const validateForm = () => {
        setFormValid(isValueEntered(selectedPortfolio?.name));
    };

    const maintainButton = (label) => {
        return (
            <Button className="text-uppercase" disabled={!formValid} color="primary" onClick={() => {
                dispatch(showPortfolioLoader());
                dispatch(onPortfolioClose());
                dispatch(onSavePortfolio(selectedPortfolio));
                setSelectedPortfolio(initProps());
                setFormValid(false);
            }}>
                {label}
            </Button>
        );
    };

    const modalHeaderOnClick = () => {
        return () => {
            setFormValid(false);
            dispatch(onPortfolioClose());
        };
    };

    const modalBody = (buttonText) => {
        return (
            <Fragment>
                <div className="modal-box-content">
                    <div className="row no-gutters">
                        {displayedImage(selectedPortfolio)}
                        {showErrors(formErrors)}
                        {inputFields(selectedPortfolio, handleUserInput)}
                    </div>
                </div>

                <div className="modal-box-footer d-flex flex-row">
                    {maintainButton(buttonText)}
                </div>
            </Fragment>
        );
    };
    
    return (
        <Modal className="modal-box" isOpen={addPortfolioState}>
            {modalHeader(<IntlMessages id="portfolio.addPortfolio" />, modalHeaderOnClick)}
            {modalBody(<IntlMessages id="portfolio.addPortfolio" />)}
        </Modal>
    );
};

export default PortfolioAdd;


// WEBPACK FOOTER //
// ./components/Agile/portfolio/portfolioMaintenance/portfolioAdd/index.js